import React from 'react';
import { PropTypes } from 'prop-types';
import Add from 'material-ui/svg-icons/content/add';
import TappableLink from '../../../components/TappableLink';
import FlatButtonLink from '../../../components/FlatButtonLink';
import Games from './DashboardGames';
import './DashboardPlayer.css';

const fullName = player => {
  const name = player.get('name');
  if (name) return name;

  const small = player.get('nameSmall');
  const large = player.get('nameLarge');

  return `${small} ${large}`.trim();
};

const DashboardPlayer = ({
  newGameLink,
  onStartCoding,
  player,
  playerDetailsLink
}) => (
  <div className="dashboard-player">
    <div className="dashboard-player__header">
      <TappableLink
        className="dashboard-player__player-name"
        to={playerDetailsLink}
      >
        {fullName(player)}
      </TappableLink>
      <FlatButtonLink to={newGameLink} icon={<Add />} label="Add Game" />
    </div>
    <Games games={player.get('games')} onStartCoding={onStartCoding} />
  </div>
);

DashboardPlayer.propTypes = {
  newGameLink: PropTypes.string.isRequired,
  onStartCoding: PropTypes.func.isRequired,
  player: PropTypes.object.isRequired,
  playerDetailsLink: PropTypes.string.isRequired
};

export default DashboardPlayer;



// WEBPACK FOOTER //
// ./src/routes/home/components/DashboardPlayer.js